import { cn } from "./utils";

interface PriceTagProps extends React.HTMLAttributes<HTMLDivElement> {
  amount: number | string;
  currency?: string;
  period?: "month" | "year" | "call" | "token" | string;
  size?: "sm" | "default" | "lg" | "xl";
}

export function PriceTag({
  amount,
  currency = "$",
  period,
  size = "default",
  className,
  ...props
}: PriceTagProps) {
  const sizeConfig = {
    sm: { currency: "text-sm", amount: "text-xl", period: "text-xs" },
    default: { currency: "text-base", amount: "text-3xl", period: "text-sm" },
    lg: { currency: "text-lg", amount: "text-4xl", period: "text-base" },
    xl: { currency: "text-xl", amount: "text-5xl", period: "text-lg" },
  };

  const css = sizeConfig[size];

  return (
    <div className={cn("flex items-baseline tracking-tight", className)} {...props}>
      <span className={cn("font-medium mr-0.5 text-muted-foreground", css.currency, size === "sm" ? "font-sans" : "font-display")}>{currency}</span>
      <span className={cn("font-bold text-foreground", css.amount, size === "sm" ? "font-sans" : "font-display")}>{amount}</span>
      {period && (
        <span className={cn("text-muted-foreground ml-1.5 font-sans font-normal", css.period)}>
          /{period}
        </span>
      )}
    </div>
  );
}
